import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";

import { Button } from "../../../components/atoms";
import HostedPagesOverlay from "../../../components/site/components/HostedPagesOverlay";
import {
  SessionOverlayContext,
  SessionOverlayState,
} from "./SessionOverlayContext";
import { SignIn } from "./SignIn";
import { SignUp } from "./SignUp";
import { TrySignIn } from "./TrySignIn";

export const SessionOverlayProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [sessionOverlayState, setSessionOverlayState] =
    useState<SessionOverlayState>({
      screen: "closed",
    });

  return (
    <SessionOverlayContext.Provider
      value={{
        sessionOverlayState,
        setSessionOverlayState,
      }}
    >
      <HostedPagesOverlay isOpen={sessionOverlayState.screen !== "closed"}>
        <div className="flex w-full items-center justify-end p-2">
          <Button
            onClick={() => {
              setSessionOverlayState({
                screen: "closed",
              });
            }}
            className="aspect-square size-10"
            intent="transparent"
          >
            <FontAwesomeIcon
              className="cursor-pointer text-xl text-gray-500"
              icon={faClose}
            />
          </Button>
        </div>
        <div className="track-height-overlay flex size-full items-center justify-center">
          <AnimatePresence mode="popLayout">
            {sessionOverlayState.screen === "try-sign-in" && (
              <motion.div
                key="try-sign-in"
                className="flex size-full items-center justify-center px-4"
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.3 }}
              >
                <TrySignIn />
              </motion.div>
            )}
            {sessionOverlayState.screen === "sign-in" && (
              <motion.div
                key="sign-in"
                className="flex size-full items-center justify-center px-4"
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.3 }}
              >
                <SignIn />
              </motion.div>
            )}
            {sessionOverlayState.screen === "sign-up" && (
              <motion.div
                key="sign-up"
                className="size-full overflow-y-auto px-4 py-8"
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.3 }}
              >
                <div className="flex w-full justify-center">
                  <SignUp
                    onSuccess={async () => {
                      setSessionOverlayState({
                        screen: "closed",
                      });
                    }}
                  />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </HostedPagesOverlay>
      {children}
    </SessionOverlayContext.Provider>
  );
};
